<template>
  <main class="home-page">
    <TopBar page-header="Startsida" />
    <div class="home-content">
      <div class="content">
        <h1 class="customer-name">
          {{ chosenCustomer.Name }}
        </h1>
        <div v-html="homeText" />
      </div>
      <br>
      <button class="button"
              @click="gotoTasks()"
      >
        <div class="buttonTextContainer">
          &nbsp;
          <span class="material-icons-round">assignment</span>
          <span class="text">{{ $t('homePage.doTasks') }}</span>
          &nbsp;
        </div>
      </button> 
      <br>
      <div v-for="file in files"
           :key="file.File"
           class="filecontent"
      > 
        <a :href="`../../static/${file.File}`"
           target="_blank"
        >{{ file.Text }} 
          <span class="material-icons-outlined"> 
            {{ file.MaterialIcon }} 
          </span> 
        </a> 
      </div>
      <br>
    </div>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import i18n from '../locales/i18n';
import { onMounted, computed } from "vue"; 
import { useStore } from "vuex"; 
import router from "@/router";

const store = useStore(); 
 
const chosenCustomer = computed(() => store.state.account.chosenCustomer || {});
const homeText = computed(() => {
  const configuredHtml = window?.siteConfig?.HOMEPAGEHTML || '';
  return configuredHtml.replace(/<h1\b[^>]*>[\s\S]*?<\/h1>/i, '');
}); 
const files = computed(() => window?.siteConfig !== undefined ? window.siteConfig.HOMEPAGEFILES : []); 

onMounted(async () => { 
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('sidebar.home')); 
}); 

function gotoTasks(){
  router.push('/tasks')
}

</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";
.home-page {
  height: 100vh;
  overflow-y: scroll;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;

  background: #ffffff;

  .home-content {
    width: 90%;
    max-width: 940px;
    margin: 0 auto;
    padding-bottom: 1rem;
    background: #E6E6E6;
    border-radius: 10px;
  }

  .button {
    @include btnBig;
    height: 40px !important;
    margin-top: 2px;
    margin-right: 0px;
    border: 1px solid var(--topbar);
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 3px;
    padding: 0px;
    padding-bottom: 5px;
    background: #4F0207;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    border-radius: 999px;

    &:hover {
      border-radius: 999px;
    }

    .buttonTextContainer{
      display: flex;
      justify-content: space-evenly;
    }
    .text{
      padding-top: 0.5rem;
    }
    .material-icons-round{
      padding-top: 0.25rem;
    }
  }

  .content {
    padding: 2rem;
    text-decoration: none;
    //font-size: 20px;

    font-size: 0.9em;
    font-weight: bold;

    .customer-name {
      margin-bottom: 1rem;
      color: var(--text);
      font-size: 28px;
      font-weight: 600;
      line-height: 1.2;
    }
  }
  .filecontent { 
    padding: 0.5rem; 
    text-decoration: none; 
    //font-size: 20px; 
 
    font-size: 0.9em; 
    font-weight: bold; 
    a{ 
      font-size: 1em; 
      .material-icons-outlined{ 
        position:relative; 
        top:5px; 
      } 
    } 
  } 
  .secondRow{
    padding-top: 0px;
  }

}

    a:link { text-decoration: none;color: #000000; }


    a:visited { text-decoration: none;color: #000000; }



    
      a:hover{
        text-decoration: underline; 
            .material-icons-outlined {
          text-decoration: underline; 

      
      }
      }
    a:active { text-decoration: none;color: #000000; }
</style>
